import { useContext } from 'react'
import { ModulesContext } from '@contexts/ModulesContext'

export const useModules = () => {
  return useContext(ModulesContext)
}
